import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "../site/Nav";
import Hero from "../site/Hero";
import Marquee from "../site/Marquee";
import Gallery from "../site/Gallery";
import OrderForm from "../site/OrderForm";
import Pricing from "../site/Pricing";
import Policies from "../site/Policies";
import About from "../site/About";
import Contact from "../site/Contact";
import ChatWidget from "../site/ChatWidget";

const Site = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="relative" data-testid="velvet-bakes-site">
      <div className="grain-overlay" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Gallery />
        <OrderForm />
        <Pricing />
        <Policies />
        <About />
        <Contact />
      </main>
      <ChatWidget />
    </div>
  );
};

export default Site;
